import React, { useState } from "react";

import { 
	DownloadOutlined
} from "@ant-design/icons";
import { 
	Select, 
	DatePicker,
	Button,
	message,
	Typography
} from "antd";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { get_invoices_journal, reports } from "../../services";
import { UserRols } from "../../constants";
import { Input } from "antd";

const { RangePicker } = DatePicker;
const { Title } = Typography;

const rangePresets = [
	{
		label: "Last 7 Days",
		value: [dayjs().add(-7, "d"), dayjs()],
	},
	{
		label: "Last 14 Days",
		value: [dayjs().add(-14, "d"), dayjs()],
	},
	{
		label: "Last 30 Days",
		value: [dayjs().add(-30, "d"), dayjs()],
	},
	{
		label: "Last 90 Days",
		value: [dayjs().add(-90, "d"), dayjs()],
	},
];

const baseInvoiceOptions = [
	{
		value:"unverified",
		label:"Sin Verificar"
	},
	{
		value:"verified",
		label:"Verificada"
	},
	{
		value:"excluded",
		label:"Excluída"
	},
	{
		value:"history",
		label:"Historia"
	},
	{
		value:"canceled",
		label:"Anulada"
	}
];

const ClientInvoiceOptions = [
	{
		value:"unverified",
		label:"Sin Verificar"
	},
	{
		value:"verified",
		label:"Verificada"
	},
	{
		value:"excluded",
		label:"Excluída"
	},
	{
		value:"canceled",
		label:"Anulada"
	}
];

const BillingInvoicePositions = [
	{
		value:"in",
		label:"Venta"
	},
];

const baseInvoicePositions = [
	{
		value:"out",
		label:"Compra"
	},
	{
		value:"in",
		label:"Venta"
	}
];

// user
export const ReportInvoicesNormalMode = ({ user, token, company, journal = false, onEmailSended = () => {} }) => {
	const [selectedState, setselectedState] = useState(null);
	const [selectedType, setselectedType] = useState(null);
	const [pageNumber, setPageNumber] = useState(null);
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [loadingReporteFacturas, setloadingReporteFacturas] = useState(false);
	const [selectedDiary, setSelectedDiary] = useState(null);

	const onChangeState = (value) => {
		setselectedState(value);
	};
	
	const onPageNumber = (value) => {
		setPageNumber(value);
	};
	
	const onChangeType = (value) => {
		setselectedType(value);
		setSelectedDiary(null);
	};

	const onRangeChange = (dates, dateStrings) => {
		if (dates) {
			setStartDate(dateStrings[0]);
			setEndDate(dateStrings[1]);
			return;
		}
		setStartDate(null);
		setEndDate(null);
	};

	const onCleanData = () => {
		setselectedState(null);
		setselectedType(null);
		setStartDate(null);
		setEndDate(null);
	};

	const onDownloadInvoices = async () => {
		
		if (journal) {
			if (company.id === "" || startDate === null ||  endDate === null || selectedType === null || selectedDiary === null) {
				message.error("No has seleccionado todos los valores");
				return;
			}
	
			setloadingReporteFacturas(true);
	
			try {
				const res = await get_invoices_journal(
					token,
					company.tid, 
					selectedType,
					startDate,
					endDate,
					pageNumber?.toString() || "1",
					String( selectedDiary )
				);
	
				if (res) {
					message.success(res);
					onEmailSended(true);
					onCleanData();
				}			
			} catch (error) {			
				message.error(error.response.data);
			} finally {
				setloadingReporteFacturas(false);
			}
		}

		else {
			if (
				company.id === "" ||  selectedState === null || selectedType === null || 
				startDate === null ||  endDate === null
			) {
				message.error("No has seleccionado todos los valores");
				return;
			}
	
			// Verificar el límite de fechas, no debe de superar los 3 meses
			const checkingStartDate = dayjs(new Date(startDate));
			const checkingEndDate = dayjs(new Date(endDate));
	
			const monthDifference = checkingEndDate.diff(checkingStartDate, "month", true);
			if (monthDifference > 3){
				message.error("El rango de fechas no puede superar los 3 meses.");
				return;
			}
		
			setloadingReporteFacturas(true);
	
			let date = new Date(endDate);
	
			// Agregar un día
			date.setDate(date.getDate() + 1);
	
			// Convertir de nuevo a cadena de texto
			let newEndDate = date.toISOString().split("T")[0];
	
			try {
				const res = await reports(
					token,
					"invoices",
					company.tid, 
					selectedState, 
					selectedType, 
					startDate, 
					newEndDate
				);
	
				if (res) {
					message.success(res);
					onEmailSended(true);
					onCleanData();
				}			
			} catch (error) {			
				message.error(error.response.data);
			} finally {
				setloadingReporteFacturas(false);
			}
		}
	};


	return (
		<div style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: "20px" }}>
			<Title>Generar {journal? "Libro" : "Reporte"}</Title>
			<Select
				showSearch
				placeholder="Selecciona un tipo"
				optionFilterProp="children"
				onChange={onChangeType}
				filterOption={(input, option) =>
					(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
				}
				style={{
					width: "100%",
					maxWidth: "400px",
					marginBottom: "10px"
				}}
				options={
					user.role === UserRols.BILLING ? 
						BillingInvoicePositions :
						baseInvoicePositions
				}
				value={selectedType}
			/>
			{
				!journal &&
				<>
					<Select
						showSearch
						placeholder="Selecciona un estado"
						optionFilterProp="children"
						onChange={onChangeState}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						style={{
							width: "100%",
							maxWidth: "400px",
							marginBottom: "10px"
						}}
						options={
							user.role === UserRols.CLIENT ? 
								ClientInvoiceOptions :
								baseInvoiceOptions
						}
						value={selectedState}
					/>
				</>
			}
			{
				journal &&
				<>
					<Input
						placeholder="Folio"
						value={pageNumber}
						style={{
							width: "100%",
							maxWidth: "400px",
							marginBottom: "10px"
						}}
						onChange={(e) => {
							const value = e.target.value;
							// Only allow integer numbers (no decimals, no letters)
							if (value === "" || /^[0-9]+$/.test(value)) {
								onPageNumber(value);
							}
						}}
						type="text"
					>
					</Input>
					<Select
						showSearch
						placeholder="Selecciona el diario"
						style={{
							width: "100%",
							maxWidth: "400px",
							marginBottom: "10px"
						}}
						onChange={(value) => setSelectedDiary(value)}
						value={selectedDiary}
						options={
							company.accounting_resources?.diaries
								.filter(item => {
									// Filter diaries based on selectedType
									if (selectedType === "in") return item.type === "sale";
									if (selectedType === "out") return item.type === "purchase";
									return false;
								})
								.map((item) => ({
									label: item.name,
									value: item.id,
								}))
						}
					>
					</Select>
				</>
			}
			<RangePicker
				presets={rangePresets}
				style={{
					width: "100%",
					maxWidth: "400px",
					marginBottom: "10px"
				}}
				onChange={onRangeChange}
				value={[
					startDate ? dayjs(startDate) : null,
					endDate ? dayjs(endDate) : null,
				]}
			/>
			<div style={{ width: "100%", maxWidth: "400px", marginTop: "15px", textAlign: "center" }}>
				<Button
					type="primary"
					icon={<DownloadOutlined />}
					size="large"
					onClick={onDownloadInvoices}
					loading={loadingReporteFacturas}
					style={{ width: "100%" }}
				>
					Enviar Reporte
				</Button>
			</div>
		</div>
	);
};

ReportInvoicesNormalMode.propTypes = {
	user: PropTypes.shape({
		email: PropTypes.string.isRequired,
		role: PropTypes.string.isRequired,
	}).isRequired,
	token: PropTypes.string.isRequired,
	company: PropTypes.shape({
		id: PropTypes.string.isRequired,
		tid: PropTypes.string.isRequired,
		accounting_resources: PropTypes.object.isRequired,
	}).isRequired,
	journal: PropTypes.bool,
	onEmailSended: PropTypes.func,
};